import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@xo-union/tk-component-icons';
import { DisplayLink } from '@xo-union/tk-ui-links';
import { Body1 } from '@xo-union/tk-ui-typography';
import styles from './template-action.scss';

const GUESTLIST_TEMPLATE = process.env.REACT_APP_GLM_GUESTLIST_TEMPLATE;
const GOOGLE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/1luPN-lVagqUX1ijF07btp5x4tOfu7XecSDpt468inEI/copy';

const TemplateAction = ({ type }) => {
  const action = type === 'download' ? 'Excel Template' : 'Google Sheet Template';
  const href = type === 'download' ? GUESTLIST_TEMPLATE : GOOGLE_SHEET_URL;
  const target = type === 'download' ? '_self' : '_blank';
  const text = type === 'download' ? 'download' : 'open';

  return (
    <div className={styles.actionContainer}>
      <Body1 className={styles.body1}>{action}</Body1>
      <DisplayLink target={target} href={href} className={styles.link} color="primary">
        <Icon name={type} size="md" />
        <span className={styles.linkText}>{text}</span>
      </DisplayLink>
    </div>
  );
};

TemplateAction.propTypes = {
  type: PropTypes.oneOf(['download', 'linkout']),
};

export default TemplateAction;
